export enum CurrencyEnum {
  PLN = 'PLN',
  USD = 'USD',
  EUR = 'EUR',
}
